/**
 * Legacy FinanceApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.financeApi`) keep resolving.
 *
 * The actual FinanceApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/finance/finance-api.service.ts
 */
angular.module("acme.common.service.financeApi", [
  "acme.common.factory.QueryStringBuilder",
]);
